import {defineStore} from "pinia";
import load from "@/common/load";
import {axiosJSONPost, getDevList} from "@/layouts/admin-sidebar/requstDev";
import userStore from "@/stores/user";
import {router} from "@/router";
import singleDev from "@/stores/singleDev";
import api from "@/service/api";

export default defineStore('devStore', {
    persist: {
        enabled: true, strategies: [{key: 'devStore', storage: sessionStorage}]
    }, state() {
        /*初始数据列表*/
        return {
            devListInfo: {}, // 存储项目列表
            // 设备列表
            filterDevList: {},
            allDev: {
                primaryDevice: ['7', '8', '26'], // 主设备
                modularEquipment: ['31', '32', '33', '35', '71', '25'], // 模块化设备
                primaryAndSecondaryNodes: 0, // 主副节点筛选
                tagFiltering: [0], // 标记筛选
                statusFiltering: 3, // 在线状态筛选
                parkingSpaceBoxFiltering: 3, // 车位框筛选
            }, // 存储筛选列表
            devId: "", //设备筛选框内容
            // 设备类型数量
            devTypeNum: {}, // 设备主副数量
            mainAndSecondary: {
                codes: 0, noCodes: 0
            }, numberOfFailures: {
                fault: 0, noFault: 0
            }, parkFrameSecondary: {
                frame: 0, noFrame: 0
            }, // 项目模式
            mode: "information", devErrorList: [], // 设备故障列表
            totalInfo: {
                total: 0, online: 0, error: 0
            }, shootParkError: {}, // 拍照车位故障
            shootCameras: {}, // 拍照车位摄像头
            ignoreType: [], // 忽略类型
        }
    }, actions: {
        // 切换项目后的初始化
        initDevStroe() {
            this.$state.totalInfo = {
                total: 0, online: 0, error: 0
            }
            this.$state.numberOfFailures = {
                fault: 0, noFault: 0
            }
            this.$state.mainAndSecondary = {
                codes: 0, noCodes: 0
            }
            this.$state.parkFrameSecondary = {
                frame: 0, noFrame: 0
            }
            this.$state.devTypeNum = {};
        },
        /* 获取项目设备列表 */
        async getDevStoreList(f) {
            let user = userStore();
            let single = singleDev();
            try {
                load.loading("加载项目信息...");
                let obj = {
                    "userId": "admin", "buildId": user.buildId
                }
                let result = await getDevList(obj);
                load.loaded();
                if (result.result === '1') {
                    this.$state.ignoreType = result.data.ignoreType;
                    result.data.deviceList.forEach(v => {
                        this.$state.shootParkError[v.floorName] = {};
                        this.$state.shootParkError[v.floorId] = {};
                        v.devices.forEach((item) => {
                            if (item.netType === null) {
                                item.netType = "0";
                            }
                            if (item.netName === null) {
                                item.netName = "0";
                            }
                            if (item.netType === '0') {
                                if (item.deviceType === '31' || item.deviceType === '32' || item.deviceType === '33') {
                                    item.netType = "main"
                                }
                            }
                            if (item.netName === '0') {
                                if (item.deviceType === '31' || item.deviceType === '32' || item.deviceType === '33') {
                                    item.netName = item.uniqueCode
                                }
                            }
                            if (item.uniqueCode) {
                                if (item.uniqueCode.substr(0, 2) === 'A8') {
                                    item.deviceType = '8'
                                }
                            }
                            // if (['31', '32', '33'].includes(item.deviceType)) {
                            //     item.errCode = 6
                            // }
                        })
                        // v.devices = v.devices.filter(item => {
                        //     return item.uniqueCode != null && item.uniqueCode !== '0'
                        // })
                        v.devices.sort((a, b) => {
                            if (a.uniqueCode === null || b.uniqueCode === null) {
                                return;
                            }
                            return a.uniqueCode.localeCompare(b.uniqueCode)
                        })
                    })
                    this.$state.filterDevList = {...result.data};
                    this.$state.devListInfo = {...result.data};
                    if (single.currentCode.qrCode === '') {
                        single.changeCurrentCode(result.data.deviceList[0].devices[0].uniqueCode, result.data.deviceList[0].devices, 'list', true);
                    }
                    if (f) {
                        f()
                    }
                    // 筛选
                    this.devChange();
                    // 整理格式
                    this.organizeFormatting();
                } else {
                    load.error(result.msg)
                }
            } catch (error) {
                load.error("加载设备列表时出错");
                console.error(error);
            }
        }, /* 根据筛选条件筛选 */
        devChange() {
            load.loading("筛选中...")
            let arr = [...this.$state.allDev.primaryDevice, ...this.$state.allDev.modularEquipment]
            // let single = singleDev();
            let filteredList = this.$state.filterDevList.deviceList.map(v => ({
                ...v,
                devices: v.devices.filter(item => arr.includes(item.deviceType) && (this.$state.allDev.primaryAndSecondaryNodes === 0 || (this.$state.allDev.primaryAndSecondaryNodes === 1 && item.netType === 'main') || (this.$state.allDev.primaryAndSecondaryNodes === 2 && item.netType === 'cm') || (this.$state.allDev.primaryAndSecondaryNodes === 3 && item.netType === '0')) && (this.$state.allDev.tagFiltering.includes(0) || this.$state.allDev.tagFiltering.includes(item.label)) && (this.$state.allDev.statusFiltering === 3 || this.$state.allDev.statusFiltering === item.online) && (this.$state.allDev.parkingSpaceBoxFiltering === 3 || this.$state.allDev.parkingSpaceBoxFiltering === item.parkFrame) && (this.$state.devId === '' || item.deviceId.includes(this.$state.devId) || item.uniqueCode.includes(this.$state.devId)))
            }))
            load.loaded();
            // 统计设备总数
            filteredList.forEach(item => {
                let online = 0;
                item.devices.forEach(v => {
                    if (v.online === 1) {
                        online++
                    }
                })
                item.online = online;
                item.total = item.devices.length;
            })

            this.$state.devListInfo.deviceList = filteredList;
        }, // 清空
        reset() {
            this.$state.filterDevList = {};
            this.$state.devListInfo = {};
        }, /* 整理格式 */
        organizeFormatting() {
            this.$state.devTypeNum = {};
            this.$state.mainAndSecondary = {
                // hostCount: 0,
                // assistCount: 0,
                // noCount: 0
                codes: 0, noCodes: 0
            };
            this.$state.numberOfFailures = {
                fault: 0, noFault: 0
            }
            this.$state.parkFrameSecondary = {
                frame: 0, noFrame: 0
            };
            if (this.$state.filterDevList.deviceList.length) {
                this.$state.filterDevList.deviceList.forEach(item => {
                    if (!this.$state.devTypeNum.hasOwnProperty(item.floorName)) this.$state.devTypeNum[item.floorName] = {}
                    item.devices.forEach(item2 => {
                        if (!this.$state.ignoreType.includes(item2.deviceType)) {
                            if (['7', '8'].includes(item2.deviceType)) {
                                if (item2.parkFrame !== 0) {
                                    this.$state.parkFrameSecondary.frame++;
                                } else {
                                    this.$state.parkFrameSecondary.noFrame++;
                                }
                            }
                        }
                        if (this.$state.devTypeNum[item.floorName].hasOwnProperty(item2.deviceType)) {
                            if (item2.online === 1) {
                                this.$state.devTypeNum[item.floorName][item2.deviceType].online++;
                            } else {
                                this.$state.devTypeNum[item.floorName][item2.deviceType].disconnected++;
                            }

                            // Check if uniqueCode is '0' and increment noCode field
                            if (item2.uniqueCode === '0') {
                                this.$state.mainAndSecondary.noCodes++;
                                if (!this.$state.devTypeNum[item.floorName][item2.deviceType].hasOwnProperty('noCode')) {
                                    this.$state.devTypeNum[item.floorName][item2.deviceType].noCode = 1;
                                } else {
                                    this.$state.devTypeNum[item.floorName][item2.deviceType].noCode++;
                                }
                            } else {
                                this.$state.mainAndSecondary.codes++;
                            }

                            if (item2.errCode != 0) {
                                this.$state.numberOfFailures.fault++;
                                if (!this.$state.devTypeNum[item.floorName][item2.deviceType].hasOwnProperty('errNum')) {
                                    this.$state.devTypeNum[item.floorName][item2.deviceType].errNum = 1;
                                } else {
                                    this.$state.devTypeNum[item.floorName][item2.deviceType].errNum++;
                                }
                            } else {
                                this.$state.numberOfFailures.noFault++;
                            }
                        } else {
                            if (item2.online === 1) {
                                this.$state.devTypeNum[item.floorName][item2.deviceType] = {
                                    online: 1,
                                    disconnected: 0,
                                    noCode: item2.uniqueCode === '0' ? 1 : 0,
                                    errNum: item2.errCode != 0 ? 1 : 0
                                };
                            } else {
                                this.$state.devTypeNum[item.floorName][item2.deviceType] = {
                                    online: 0,
                                    disconnected: 1,
                                    noCode: item2.uniqueCode === '0' ? 1 : 0,
                                    errNum: item2.errCode != 0 ? 1 : 0
                                };
                            }
                        }

                    })
                })
                this.$state.totalInfo = {
                    total: 0, online: 0, error: 0
                }
                for (let devTypeNumKey in this.$state.devTypeNum) {
                    for (let devTypeNumElementKey in this.$state.devTypeNum[devTypeNumKey]) {
                        if (this.$state.ignoreType.includes(devTypeNumElementKey)) {
                            continue;
                        }
                        this.$state.totalInfo.total += this.$state.devTypeNum[devTypeNumKey][devTypeNumElementKey].online + this.$state.devTypeNum[devTypeNumKey][devTypeNumElementKey].disconnected;
                        this.$state.totalInfo.online += this.$state.devTypeNum[devTypeNumKey][devTypeNumElementKey].online;
                        this.$state.totalInfo.error += this.$state.devTypeNum[devTypeNumKey][devTypeNumElementKey].disconnected;
                    }
                }
                // 获取设备故障
                this.getDevErrorList();
            }
        }, // 获取设备故障数量
        getDevErrorList() {
            this.$state.devErrorList = [];
            let user = userStore();
            this.$state.filterDevList.deviceList.forEach(async (item) => {
                let res = await axiosJSONPost(api.getCameraList, {
                    "floor_id": item.floorId,
                    "build_id": user.buildId,
                    "user_id": "beefind",
                    "che": "1",
                    "pag": "0",
                    "floor": 1,
                });
                let res2 = await axiosJSONPost(api.getCameraLine, {
                    userId: 'beefind', buildId: user.buildId, floorId: item.floorId,
                });
                // 先选出对拍摄像头
                let shootTheCamera = new Set([]);
                // 对拍摄像头数组
                let shootCameras = [];
                // 对拍故障摄像头数组
                let shootErrorCameras = new Set([]);
                res2.data.rgbLines.forEach(rgb => {
                    shootTheCamera.add(rgb.rgb_id);
                });
                let uniquCodes = {};
                // 给摄像头id赋值uniqucode
                item.devices.forEach(items => {
                    uniquCodes[items.deviceId] = items
                })
                // 挑出对拍摄像头颜色不对的
                res.camera_list.forEach(camera => {
                    camera.uniqueCode = '0';
                    if (shootTheCamera.has(camera.camera_id)) {
                        camera.data = {...uniquCodes[camera.camera_id]};
                        shootCameras.push(camera)
                    }
                });
                let noCode = new Set([]);
                // 统计故障数量
                shootCameras.forEach(camera => {
                    if (camera.rg_color === '000000' && Object.values(camera.data).length) {
                        shootErrorCameras.add(camera.camera_id)
                        if (camera.data.uniqueCode === '0' || camera.data.uniqueCode === null) {
                            noCode.add(camera.data.deviceId);
                        }
                    }
                });
                this.$state.shootParkError[item.floorName]['total'] = shootCameras.length;
                this.$state.shootParkError[item.floorName]['online'] = shootCameras.length - shootErrorCameras.size;
                this.$state.shootParkError[item.floorName]['disconnected'] = shootErrorCameras.size - noCode.size;
                this.$state.shootParkError[item.floorName]['noCode'] = noCode.size;
                this.$state.shootParkError[item.floorName]['data'] = shootErrorCameras;
                this.$state.shootParkError[item.floorId]['total'] = shootCameras.length;
                this.$state.shootParkError[item.floorId]['online'] = shootCameras.length - shootErrorCameras.size;
                this.$state.shootParkError[item.floorId]['disconnected'] = shootErrorCameras.size;
                this.$state.shootParkError[item.floorId]['noCode'] = noCode.size;
                this.$state.shootParkError[item.floorId]['data'] = shootErrorCameras;
                this.$state.shootCameras[item.floorId] = {};
                this.$state.shootCameras[item.floorId] = [...shootCameras];
            })
        }, /*  切换模式 */
        changeMode() {
            if (this.$state.mode === 'tag') {
                router.replace('/dash/tag')
            } else {
                router.replace('/')
            }
        }
    }
})
